export default "/build/images/4head.png?0664276dc1d7cb53184e428914a9c639";